@import frontend/shared/stylesheets/environment

.huge-notification-mobile
  position: relative
  padding: 20px 35px 20px 15px

  background: #fff

  font-size: 16px
  +media-breakpoint-down(md)
    font-size: 14px
  +media-breakpoint-only(xs)
    line-height: 1.33
    font-size: 13px

  +media-breakpoint-up(lg)
    display: none

.huge-notification-mobile--body
  overflow-y: hidden
  margin-bottom: 50px

.huge-notification-mobile--subline
  font-size: 0.85em

.huge-notification-mobile--reload
  font-weight: bold
  color: $link-color
  +button-link
  +button-hover
